import {
  createFrontendModule,
  ApiBlueprint,
} from '@backstage/frontend-plugin-api';
import { createApiFactory } from '@backstage/core-plugin-api';
import { CodeSnippet } from '@backstage/core-components';
import {
  apiDocsConfigRef,
  defaultDefinitionWidgets,
} from '@backstage/plugin-api-docs';
import { EventDefinitionWidget, SubEventDefinitionWidget } from './EventWidgets';
import { SubgraphDefinitionWidget } from './SubgraphWidget';
import { ProtoDefinitionWithBrowser } from './ProtoDefinitionWithBrowser';

const apiDocsConfigOverride = ApiBlueprint.make({
  name: 'config',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: apiDocsConfigRef,
        deps: {},
        factory: () => {
          const defaultWidgets = defaultDefinitionWidgets();
          const customWidgets = [
            {
              type: 'graphql-subgraph',
              title: 'Subgraph Schema',
              rawLanguage: 'graphql',
              component: (definition: string) => (
                <SubgraphDefinitionWidget definition={definition} />
              ),
            },
            {
              type: 'grpc',
              title: 'gRPC',
              rawLanguage: 'protobuf',
              component: (definition: string) => (
                <ProtoDefinitionWithBrowser definition={definition} label="Service" />
              ),
            },
            {
              type: 'event',
              title: 'Event',
              rawLanguage: 'protobuf',
              component: (definition: string) => (
                <EventDefinitionWidget definition={definition} />
              ),
            },
            {
              type: 'sub-event',
              title: 'Event',
              rawLanguage: 'protobuf',
              component: (definition: string) => (
                <SubEventDefinitionWidget definition={definition} />
              ),
            },
            {
              type: 'database-schema',
              title: 'Schema',
              rawLanguage: 'sql',
              component: (definition: string) => (
                <CodeSnippet
                  text={definition}
                  language="sql"
                  showLineNumbers
                  showCopyCodeButton
                />
              ),
            },
            {
              type: 'async',
              title: 'Protobuf',
              rawLanguage: 'protobuf',
              component: (definition: string) => (
                <CodeSnippet
                  text={definition}
                  language="protobuf"
                  showLineNumbers
                  showCopyCodeButton
                />
              ),
            },
            ...defaultWidgets,
          ];
          return {
            getApiDefinitionWidget: (apiEntity: {
              spec: { type: string };
            }) => {
              return customWidgets.find(w => w.type === apiEntity.spec.type);
            },
          };
        },
      }),
    ),
});

/** Extends the api-docs plugin with custom definition widgets for SQL, Protobuf, and Events. */
export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [apiDocsConfigOverride],
});
